// Set a limit to a number, or to UNLIMITED to remove the cap entirely.
export const UNLIMITED = Infinity;

// Max images per top-level entity image gallery (Tier, Equipment, Component,
// Instrument — both their Edit and New forms). Update this if the business
// wants a different photo-count cap for those galleries.
export const MAX_GALLERY_IMAGES = 30;

// Max images per sub-asset row in NewEquipment's bulk "add tiers" table —
// a separate, smaller cap since it's per-row within a bulk-entry grid, not
// a full entity gallery. Update this independently of MAX_GALLERY_IMAGES.
export const MAX_SUBASSET_ROW_IMAGES = 5;
